import { CreditsScreen } from "./Credits/CreditsScreen";
import { HomeScreen } from "./Home/HomeScreen";
export function RegisterScreens() {
    HomeScreen();
    CreditsScreen();
}
